import { Component } from '@angular/core';

import { DashboardStore, ENGINE_JOBS_QUERY_LIMIT, sortByValues } from '../dashboardv2.store';

@Component({
  selector: 'app-engine-preview',
  templateUrl: './engine-preview.component.html',
  styleUrl: './engine-preview.component.scss'
})
export class EnginePreviewComponent {

  engineJobs$ = this.dashboardStore.engineJobsViewModel$;

  sortByOptions = sortByValues;

  setSortBy = this.dashboardStore.setSortEngineJobsBy;

  fetchingMoreSkeletons = new Array(ENGINE_JOBS_QUERY_LIMIT).fill(0);

  constructor(
    private dashboardStore: DashboardStore,
  ) {}

}
